import { createRouter, createWebHistory } from "vue-router";
import Browser from "/src/views/TheBrowser.vue";
const routes = [
  {
    path: "/",
    name: "Browser",
    component: Browser,
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});
export default router;
